import { Box, Button } from "@vinomofo/components";
import { Fragment, useState } from "react";

import { InstantSearchProvider } from "../instant-search/InstantSearchProvider";
import { SearchIcon } from "@vinomofo/icons";
import SearchProvider from "../../contexts/search/provider";

let DynamicSearchModal;
export interface HeaderSearchProps {
  modalVisible?: boolean;
  size?: string;
}

export const HeaderSearch = ({
  modalVisible,
  size = "25px",
}: HeaderSearchProps): JSX.Element => {
  const [visible, setVisible] = useState(modalVisible || false);

  return (
    <Fragment>
      <Box>
        <Button
          color="white"
          onClick={async () => {
            DynamicSearchModal = await import("./SearchModal").then(
              (module) => module.SearchModal
            );
            setVisible(true);
          }}
        >
          <SearchIcon size={size} />
        </Button>
        {DynamicSearchModal && (
          <SearchProvider>
            <DynamicSearchModal
              onClose={() => setVisible(false)}
              visible={visible}
            />
          </SearchProvider>
        )}
      </Box>

    </Fragment>
  );
};
